import { Trash2, Ticket } from 'lucide-react';
import type { Coupon } from '../../types/promotion';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  EmptyState
} from '../ui';

interface CouponListProps {
  coupons: Coupon[];
  onDelete: (coupon: Coupon) => void;
  isLoading?: boolean;
}

function CouponList({ coupons, onDelete, isLoading }: CouponListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (coupons.length === 0) {
    return (
      <EmptyState
        icon={<Ticket className="h-12 w-12" />}
        title="Nenhum cupom distribuído"
        description="Distribua cupons para os participantes"
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Participante</TableHead>
            <TableHead>Quantidade</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {coupons.map((coupon) => (
            <TableRow key={coupon.id}>
              <TableCell>{coupon.participant_name}</TableCell>
              <TableCell>{coupon.quantity}</TableCell>
              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  onClick={() => onDelete(coupon)}
                  title="Excluir"
                >
                  <Trash2 className="h-4 w-4 text-red-600" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CouponList;